import PropTypes from 'prop-types';
import React, { Component } from 'react';

import moment from 'moment';
import { getDisplayAction } from 'utils/formatters/stops';
import { sluggify } from 'utils/localization/utils';
import { withTranslation } from 'react-i18next';
import { extractLocation } from '../../../../helpers/locations';

import StopAppointmentWindow from '../stops/StopAppointmentWindow';

const getStopAddress = (location, yardName) => {
  const parsedLocation = extractLocation(location);

  const { suite_or_apt, name, street, city, state, zipcode } = parsedLocation;

  if (!parsedLocation) {
    return null;
  }

  let locationStreet;
  if (suite_or_apt) {
    locationStreet = `${street}, Suite ${suite_or_apt}`;
  } else {
    locationStreet = street;
  }

  return (
    <div>
      {name && <p className="mb-2 font-bold">{yardName || name}</p>}
      <p className="mb-2">{locationStreet}</p>
      <p className="mb-2">
        {city}, {state} {zipcode}
      </p>
    </div>
  );
};

class Stop extends Component {
  static propTypes = {
    stop: PropTypes.shape({
      sequence: PropTypes.number.isRequired,
      intent: PropTypes.oneOf(['pickup', 'delivery']).isRequired,
      empty: PropTypes.bool.isRequired,
      window_start: PropTypes.string,
      window_end: PropTypes.string,
      appointment_unconfirmed: PropTypes.bool.isRequired,
      location: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          address: PropTypes.string,
        }),
      ),
    }).isRequired,
    shipment_type: PropTypes.oneOf(['shorthaul', 'drayage']),
    appointmentEditable: PropTypes.bool.isRequired,
    onEditAppointmentWindow: PropTypes.func.isRequired,
    yardName: PropTypes.string,
  };

  handleEditAppointmentWindow = () =>
    this.props.onEditAppointmentWindow(this.props.stop);

  render() {
    const { stop, shipment_type, appointmentEditable, yardName } = this.props;

    const { sequence } = stop;
    return (
      <div className="flex flex-wrap py-4 text-sm bg-white rounded -mx">
        <div className="flex items-center justify-center w-8 h-8 px-4 text-white rounded-full bg-blue-darker">
          {sequence}
        </div>
        <div className="px-4" style={{ width: '80px' }}>
          {this.props.t(sluggify(getDisplayAction(stop)))}
        </div>
        <div className="px-4 md:w-1/3">
          {getStopAddress(stop.location, yardName)}
        </div>
        <div className="px-2 md:w-1/3">
          <StopAppointmentWindow
            onEditAppointmentWindow={this.handleEditAppointmentWindow}
            stop={stop}
            shipment_type={shipment_type}
            editable={appointmentEditable}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(Stop);
